import { ACTIVE_CLASS_NAME } from 'modules/nav/constants';
import { NavbarOption } from 'modules/nav/types';
import { NavLink } from 'react-router-dom';
import { HEADER_NAV_ICONS } from 'ui/icons/headerNavigation/constants';
import { Description, IconContainer, MenuLink, Title } from './LinkContainer.styled';

type Props = {
  className?: string;
  isActive: boolean;
  option: NavbarOption;
  shouldOpenInNewTab: boolean;
  'data-test'?: string;
};

export const NavigationMenuLink = ({
  className = '',
  isActive,
  option,
  shouldOpenInNewTab,
  ...props
}: Props) => {
  const { isExternal, href, icon } = option;
  const attributes = shouldOpenInNewTab ? { rel: 'noopener noreferrer', target: '_blank' } : {};

  return (
    <MenuLink
      {...attributes}
      data-test={props['data-test'] || 'navigation-menu-link'}
      as={isExternal ? 'a' : NavLink}
      activeClassName={ACTIVE_CLASS_NAME}
      className={`${className} ${!isExternal && isActive ? ACTIVE_CLASS_NAME : ''}`.trim()}
      data-type={isExternal ? 'anchor' : 'navlink'} // for testing purposes
      href={isExternal ? (href as string) : ''}
      to={isExternal ? '' : (href as string)}
      exact
    >
      {icon && <IconContainer>{HEADER_NAV_ICONS[icon]}</IconContainer>}
      <Title isHeading={!!option.pageDescription}>{option.title}</Title>
      <Description>{option.pageDescription}</Description>
    </MenuLink>
  );
};
